export const SIZE_CONFIG: Record<"sm" | "default" | "lg" | "xl", string> = {
  sm: "size-3",
  default: "size-4",
  lg: "size-6",
  xl: "size-8",
};
